// import { optionSelectAll } from "@/utils/commonUtils";

const danhSachDanhMucHeThong = state => state.danhSachDanhMucHeThong;

export default {
  danhSachDanhMucHeThong
};
